import { render, staticRenderFns } from "./InfoCardList.vue?vue&type=template&id=b4ac1138&scoped=true&"
import script from "./InfoCardList.vue?vue&type=script&lang=js&"
export * from "./InfoCardList.vue?vue&type=script&lang=js&"
import style0 from "./InfoCardList.vue?vue&type=style&index=0&id=b4ac1138&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4ac1138",
  null
  
)

export default component.exports